var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BSCModal"},[_c('div',{staticClass:"BSCModal-background",class:{ 'is-opaque': _vm.opaque },on:{"click":function($event){return _vm.$emit('close')}}}),_c('transition',{attrs:{"name":"BSCModal"}},[_c('div',{staticClass:"BSCModal-content",style:(_vm.styleMain)},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }